<template>
  <div class="green-background">
    <NavBar></NavBar>
    <MainSlider></MainSlider>
    <LinesOfActivity></LinesOfActivity> 
    <HumanResources></HumanResources>
    <Footer></Footer>
    <go-top></go-top>
  </div>
</template>

<script>
  import NavBar from '@/components/shared/NavBar.vue';
  import MainSlider from '@/components/MainSlider.vue';
  import LinesOfActivity from '@/components/LinesOfActivity.vue';
  //import PressRoom from '@/components/PressRoom.vue';
  import HumanResources from '@/components/HumanResources.vue';
  import Footer from '@/components/shared/Footer.vue';
  import GoTop from '@inotom/vue-go-top';


  export default {
    name: 'App',
    components: {
      NavBar,
      MainSlider,
      LinesOfActivity,
      //PressRoom,
      HumanResources,
      Footer,
      GoTop
    }
  }
</script>

<style>

</style>